import { Drawer, Hidden, List, ListItem, ListItemText } from "@material-ui/core";
import * as React                                       from "react";
import { FC }                                           from "react";
import { useDispatch, useSelector }                     from "react-redux";
import MenuType                                         from "../../../domain/menu/MenuType";
import { ResKaState }                                   from "../../../index";
import GlobalDispatcher                                 from "../../../infrastructure/redux/global/GlobalDispatcher";
import MenuCustomersButton                              from "./MenuCustomersButton";
import "./MenuList.scss";
import MenuListNoticeButton                             from "./MenuListNoticeButton";
import MenuListSettingButton                            from "./MenuListSettingButton";
import MenuMailButton                                   from "./MenuMailButton";
import MenuPlanButton                                   from "./MenuPlanButton";
import MenuReservationButton                            from "./MenuReservationButton";

interface Props {
  menuType: MenuType;
}

const MenuList: FC<Props> = (props: Props) => {
  const isOpenSpMenu: boolean = useSelector((state: ResKaState) => state.globalState.isOpenSpMenu);
  const globalDispatcher: GlobalDispatcher = new GlobalDispatcher(useDispatch());

  const {menuType} = props;
  return (
    <>
      <Hidden smDown={ true }>
        <Drawer anchor="left" variant="permanent" className="reska-menu">
          <List disablePadding={ true } component="nav" className="reska-menu-list">
            <ListItem divider={ true } className="reska-menu-title">
              <ListItemText disableTypography={ true } primary="ResKa" className="reska-menu-title-content"/>
            </ListItem>

            <MenuListNoticeButton menuType={ menuType }/>
            <MenuCustomersButton menuType={ menuType }/>
            <MenuMailButton menuType={ menuType }/>
            <MenuReservationButton menuType={ menuType }/>
            <MenuPlanButton menuType={ menuType }/>
            <MenuListSettingButton menuType={ menuType }/>
          </List>
        </Drawer>
      </Hidden>

      <Hidden mdUp={ true }>
        <Drawer
          anchor="left"
          variant="temporary"
          className="reska-menu"
          open={ isOpenSpMenu }
          onClose={ () => globalDispatcher.toggleSpMenu() }
        >
          <List disablePadding={ true } component="nav" className="reska-menu-list">
            <ListItem divider={ true } className="reska-menu-title">
              <ListItemText disableTypography={ true } primary="ResKa" className="reska-menu-title-content"/>
            </ListItem>

            <MenuListNoticeButton menuType={ menuType }/>
            <MenuCustomersButton menuType={ menuType }/>
            <MenuMailButton menuType={ menuType }/>
            <MenuReservationButton menuType={ menuType }/>
            <MenuListSettingButton menuType={ menuType }/>
          </List>
        </Drawer>
      </Hidden>
    </>
  );
};

export default MenuList;
